import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import metricsChartContainer from '@store/metricsChartContainer/reducer';
import summaryWidgets from '@store/summaryWidgets/reducer';
import networkRequest from '@store/networkRequest/reducer';
import comparison from '@store/comparison/reducers';
import {
  SCOPE as dimensionListScope,
  reducer as dimensionList,
} from '@store/common/dimensionList';
import {
  SCOPE as birdChartScope,
  reducer as birdChart,
} from '@store/common/birdChart';
import {
  SCOPE as sharingScope,
  reducer as sharing,
} from '@store/common/sharing';
import {
  SCOPE as dimensionTablesScope,
  reducer as dimensionTables,
} from '@store/dimensionTables';
import summaryContainer from '@store/summaryContainer/reducers';
import common from '@store/common/reducer';
import dimensionContainer from '@store/dimensionContainer/reducer';
import filterContainer from '@store/filterContainer/reducer';
import persistenceStore from '@store/persistentConfig/reducer';
import { SCOPE as persistenceScope } from '@store/persistentConfig/types';
import { SCOPE as trendsScope, reducer as trends } from '@store/trends';
import {
  SCOPE as defaultLandingPageScope,
  reducer as defaultLandingPageStore,
} from '@store/defaultLandingPage';

import {
  SCOPE as errorDiagnosticsScope,
  reducer as errorDiagnostics,
} from '@store/errorDiagnostics';

import {
  SCOPE as dashboardsScope,
  reducer as dashboards,
} from '@store/dashboards';
import {
  SCOPE as tempDashboardScope,
  reducer as tempDashboard,
} from '@store/tempDashboard';

import {
  SCOPE as ViewerSessionsScope,
  ViewerSessionsReducer,
} from '@store/viewerSessions';
import { reducer as admin } from '@store/admin';
import {
  reducer as nocReducer,
  SCOPE as nocScope,
} from '@store/noc';
import {
  reducer as metricLensReducer,
  SCOPE as metricLensScope,
} from '@store/metricLens';
import {
  reducer as errorConfigReducer,
  SCOPE as errorConfigScope,
} from '@store/errorLogicConfig';
import {
  reducer as overviewDashboardReducer,
  SCOPE as overviewDashboardscope,
} from '@store/overviewDashboard';
import {
  reducer as serviceIntegrationsReducer,
  SCOPE as serviceIntegrationsScope,
} from '@store/serviceIntegrations';
import {
  reducer as aiAlertsReducer,
  SCOPE as aiAlertsScope,
} from '@store/aiAlerts';
import {
  reducer as VMReducer,
  SCOPE as VMScope,
} from '@store/viewerModule';
import {
  reducer as timelineReducer,
  SCOPE as timelineScope,
} from './store/timeline';
import { SCOPE as policiesScope, reducer as policies } from './store/policies';
import { SCOPE as changeLogScope, reducer as changeLog } from './store/changeLog';
import {
  reducer as sharedTabsReducer,
  SCOPE as sharedTabsScope,
} from './store/sharedTabs';

import {
  reducer as tempDashboardTabReducer,
  SCOPE as tempDashboardTabScope,
} from './store/tempDashboardTab';

import {
  SCOPE as appViewerSessionsScope,
  reducers as appViewerSessionsReducer,
} from './store/appViewerSessions';

export default history => combineReducers({
  router: connectRouter(history),
  filterContainer,
  metricsChartContainer,
  summaryWidgets,
  networkRequest,
  dimensionContainer,
  comparison,
  common,
  summaryContainer,
  [trendsScope]: trends,
  [sharingScope]: sharing,
  [dimensionTablesScope]: dimensionTables,
  [dimensionListScope]: dimensionList,
  [birdChartScope]: birdChart,
  [errorDiagnosticsScope]: errorDiagnostics,
  [dashboardsScope]: dashboards,
  [persistenceScope]: persistenceStore,
  [tempDashboardScope]: tempDashboard,
  [ViewerSessionsScope]: ViewerSessionsReducer,
  admin,
  [policiesScope]: policies,
  [changeLogScope]: changeLog,
  [sharedTabsScope]: sharedTabsReducer,
  [timelineScope]: timelineReducer,
  [nocScope]: nocReducer,
  [metricLensScope]: metricLensReducer,
  [defaultLandingPageScope]: defaultLandingPageStore,
  [errorConfigScope]: errorConfigReducer,
  [overviewDashboardscope]: overviewDashboardReducer,
  [serviceIntegrationsScope]: serviceIntegrationsReducer,
  [aiAlertsScope]: aiAlertsReducer,
  [VMScope]: VMReducer,
  [tempDashboardTabScope]: tempDashboardTabReducer,
  [appViewerSessionsScope]: appViewerSessionsReducer,
});
